var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-image-holder"},[_c('b-img',{staticClass:"page-image",attrs:{"src":_vm.imagesrc,"alt":""}}),_c('PageTitle',{attrs:{"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }